module.exports = __webpack_public_path__ + "img/pcms.5dc2970d.png";